/**
 * Created by andrey on 01.03.2021.
 */

const UnitsSyncerFormat = {};

UnitsSyncerFormat.REGULAR = {
    encodeUnit: function (data, x, y, code) {
        const info = cleverapps.clone(data, true);
        delete info.code;

        info.x = x;
        info.y = y;
        info._compact = info._compact || UnitPacker.compactUnit(info, code);

        return info;
    },

    decodeUnit: function (data, code) {
        const info = cleverapps.clone(data, true);
        info.code = code;
        if (!info._unknown) {
            delete info._compact;
        }
        return info;
    },

    encodeFamily: function (data, code) {
        return UnitPacker.compactUnits(Object.values(data), code);
    },

    decodeFamily: function (data, code) {
        if (!data) {
            return {};
        }
        if (typeof data === "object") {
            return data;
        }
        if (typeof data === "string" && data.charAt(0) === "{") {
            return JSON.parse(data);
        }
        const out = {};
        UnitPacker.expandUnits(data, code).forEach((unit) => {
            out[`${unit.x}_${unit.y}`] = this.encodeUnit(unit, unit.x, unit.y, code);
        });
        return out;
    }
};

UnitsSyncerFormat.INTACT = {
    encodeUnit: function (data, x, y) {
        return UnitPacker.compactCoordinate(x) + UnitPacker.compactCoordinate(y);
    },

    decodeUnit: function (data, code) {
        return {
            code,
            stage: 0
        };
    },

    encodeFamily: function (data) {
        return Object.values(data).join("");
    },

    decodeFamily: function (data) {
        const out = {};
        data = data || "";

        for (let index = 0; index < data.length;) {
            const coordinates = UnitPacker.splitCoordinates(data, index);
            const x = UnitPacker.expandCoordinate(coordinates.x);
            const y = UnitPacker.expandCoordinate(coordinates.y);

            out[`${x}_${y}`] = this.encodeUnit({}, x, y);

            index += coordinates.x.length + coordinates.y.length;
        }
        return out;
    }
};
